export default {

// TOP SECTION

    title: `Carte blanche à Tiina Itkonen`,
    subTitle: `Futurama`,

    intro: `La photographe finlandaise documente les communautés inuites et les paysages du nord du Groenland depuis plus de vingt ans. Elle photographie la vie des chasseurs de subsistance et de leurs familles, et comment elle est affectée par la sédentarisation et le changement climatique. <br/><a href="http://tiinaitkonen.com/" target="_blank">Découvrez son travail.</a>`,

};

